class PartItemQueryHelper {
  constructor() {
    this.PART_ITEMS_MAP = {};
  }

  addPartItems(items, parentId) {
    items.forEach(item => {
      this.PART_ITEMS_MAP[item.value] = {
        ...item,
        parentId
      };
    });
  }
  filterPartGroupIds(partGroupIds, partTypeIds) {
    let partTypeParentIds = [];

    partTypeIds &&
      partTypeIds.forEach(type => {
        let foundItem = this.PART_ITEMS_MAP[type];

        if (
          foundItem &&
          foundItem.parentId &&
          partTypeParentIds.indexOf(foundItem.parentId) === -1
        ) {
          partTypeParentIds.push(Number(foundItem.parentId));
        }
      });

    let filteredIds = partGroupIds.filter(
      id => partTypeParentIds.indexOf(Number(id)) === -1
    );

    return filteredIds;
  }
}

export default new PartItemQueryHelper();
